module.exports = __webpack_public_path__ + "static/media/logo-alert-gasoil.62bdd540.svg";